import { logError } from '../logError'

export function extractJson(inputString: string): any[] {
    try {
        // Strategy 1: Try to find the first valid JSON array by looking for patterns
        // that indicate the start of a JSON array with objects
        const jsonArrayPattern = /\[\s*\{[\s\S]*\}\s*\]/
        const jsonMatch = inputString.match(jsonArrayPattern)

        if (jsonMatch) {
            let jsonStr = jsonMatch[0]
            // Replace single quotes with double quotes for valid JSON
            jsonStr = jsonStr.replace(/'/g, '"')
            const parsedJson = JSON.parse(jsonStr)
            return parsedJson
        }

        // Strategy 2: Fallback - try to find content between the last '[' and last ']'
        // This handles cases where garbage might have '[' but the actual JSON is at the end
        const lastBracketMatch = inputString.match(/.*\[([\s\S]+)\]$/)
        if (lastBracketMatch) {
            let jsonStr = lastBracketMatch[1]
            jsonStr = jsonStr.replace(/'/g, '"')
            const parsedJson = JSON.parse(`[${jsonStr}]`)
            return parsedJson
        }

        // Strategy 3: Try to find any valid JSON array by iterating through potential start positions
        for (let i = 0; i < inputString.length; i++) {
            if (inputString[i] === '[') {
                try {
                    const potentialJson = inputString.substring(i)
                    const endBracket = potentialJson.lastIndexOf(']')
                    if (endBracket !== -1) {
                        let candidate = potentialJson.substring(0, endBracket + 1)
                        candidate = candidate.replace(/'/g, '"')
                        const parsed = JSON.parse(candidate)
                        if (Array.isArray(parsed)) {
                            return parsed
                        }
                    }
                } catch {
                    // Continue to next '[' position
                    continue
                }
            }
        }

        return []
    } catch (error) {
        logError('extractJson', error)
        return []
    }
}
